import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSheet,{staticClass:"mt-6",attrs:{"id":"dashboard-container"}},[_c('div',{ref:"iframeContainer",style:(("height: " + _vm.usableHeight + "px;"))},[_c('iframe',{ref:"dashboardIframe",attrs:{"frameborder":"0","width":"100%","height":"100%","src":_vm.dashboardUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }